<ion-app>
  @if (isShellVisible) {
    <ion-split-pane
      class="admin-split-pane"
      [class.admin-split-pane--collapsed]="isSidebarCollapsed && !isCompactViewportActive"
      contentId="main-content"
      [when]="!isCompactViewportActive">
      <ion-menu
        class="admin-menu"
        [class.admin-menu--collapsed]="isSidebarCollapsed && !isCompactViewportActive"
        contentId="main-content"
        menuId="admin-menu"
        [type]="isCompactViewportActive ? 'overlay' : 'reveal'"
      >
        <ion-content class="admin-menu__content">
          <aside class="admin-sidebar"
                 [class.admin-sidebar--collapsed]="isSidebarCollapsed && !isCompactViewportActive">
            <div class="admin-sidebar__brand">
              <div class="flex justify-center">
                <img
                  [src]="isSidebarCollapsed && !isCompactViewportActive ? 'assets/icon/em_icon.svg' : 'assets/icon/em_logo_white.svg'"
                  alt="EnergyMaster"
                  class="{{isSidebarCollapsed && !isCompactViewportActive ? 'w-12 h-12' :  'w-72'}} m-0"/>
              </div>

              @if (isCompactViewportActive) {
                <ion-menu-toggle class="block" [autoHide]="false">
                  <button
                    class="admin-sidebar__close"
                    type="button"
                    [attr.aria-label]="'nav.close_admin_menu' | translate"
                    (click)="closeMenu()">
                    <fa-icon [icon]="faXmark" aria-hidden="true"></fa-icon>
                  </button>
                </ion-menu-toggle>
              }
            </div>

            @if (!isCompactViewportActive) {
              <button
                class="admin-sidebar__toggle"
                type="button"
                [attr.aria-label]="(isSidebarCollapsed ? 'nav.open_navigation' : 'nav.collapse_navigation') | translate"
                (click)="toggleSidebar()">
                <fa-icon [icon]="isSidebarCollapsed ? faBars : faArrowLeftLongToLine" aria-hidden="true"
                         class="text-2xl"></fa-icon>
              </button>
            }

            @for (section of adminNavSections; track section.id) {
              <nav class="admin-nav"
                   [class.admin-nav--center]="section.modifier === 'center'"
                   [class.admin-nav--bottom]="section.modifier === 'bottom'"
                   [attr.aria-label]="section.label | translate">
                @for (item of section.items; track item.route) {
                  @if (hasChildren(item)) {
                    <div>
                      <button class="admin-nav__item justify-between typo-admin-menu"
                              [class.admin-nav__item--active]="isItemActive(item)"
                              type="button" [attr.aria-expanded]="isSubmenuOpen(item)"
                              (click)="toggleSubmenu(item)">
                        <span class="flex items-center gap-2">
                          <fa-icon class="h-6" [icon]="item.icon" aria-hidden="true"></fa-icon>
                          @if (!isSidebarCollapsed || isCompactViewportActive) {
                            <span class="max-w-56 overflow-hidden">{{ item.label | translate }}</span>
                          }
                        </span>

                        @if (!isSidebarCollapsed || isCompactViewportActive) {
                          <fa-icon [icon]="faChevronDown" aria-hidden="true"></fa-icon>
                        }
                      </button>

                      @if (!isSidebarCollapsed || isCompactViewportActive) {
                        <div class="admin-nav__sublist" [class.admin-nav__sublist--open]="isSubmenuOpen(item)">
                          @for (child of item.children!; track child.route) {
                            @if (child.disabled) {
                              <span class="admin-nav__subitem cursor-default opacity-40 typo-admin-sub-menu"
                                    aria-disabled="true">
                                {{ child.label | translate }}
                              </span>
                            } @else {
                              <ion-menu-toggle class="block" [autoHide]="false">
                                <a class="admin-nav__subitem typo-admin-sub-menu"
                                   [class.admin-nav__subitem--active]="isChildItemActive(child)"
                                   [routerLink]="child.route"
                                   (click)="closeMenu()"
                                >
                                  {{ child.label | translate }}
                                </a>
                              </ion-menu-toggle>
                            }
                          }
                        </div>
                      }
                    </div>
                  } @else {
                    <ion-menu-toggle class="block" [autoHide]="false">
                      <a
                        class="admin-nav__item typo-admin-menu"
                        [class.admin-nav__item--active]="isItemActive(item)"
                        [routerLink]="item.route"
                        (click)="closeMenu()"
                      >
                        <fa-icon class="admin-nav__icon" [icon]="item.icon" aria-hidden="true"></fa-icon>
                        @if (!isSidebarCollapsed || isCompactViewportActive) {
                          <span class="max-w-56 overflow-hidden">{{ item.label | translate }}</span>
                        }
                      </a>
                    </ion-menu-toggle>
                  }
                }
              </nav>
            }

            @if (!hasAccountNavigation) {
              <div class="admin-sidebar__logout-divider" aria-hidden="true"></div>
            }

            <button
              class="admin-sidebar__logout typo-admin-menu"
              type="button"
              [disabled]="isLoggingOut"
              [attr.aria-label]="'general.logout' | translate"
              (click)="logout()"
            >
              <fa-icon class="admin-sidebar__logout-icon" [icon]="faArrowLeftFromBracket" aria-hidden="true"></fa-icon>
              @if (!isSidebarCollapsed || isCompactViewportActive) {
                <span>{{ 'general.logout' | translate }}</span>
              }
            </button>

            <div class="admin-sidebar__footer">
              <div class="admin-sidebar__user">
                <app-user-avatar
                  class="admin-sidebar__user-avatar"
                  [user]="sidebarUser"
                  size="small"
                  fallbackInitials="AD"
                />

                @if (!isSidebarCollapsed || isCompactViewportActive) {
                  <span class="admin-sidebar__user-details">
                    <span class="admin-sidebar__user-name">{{ sidebarUserName }}</span>
                    <span class="admin-sidebar__user-mail">{{ sidebarUserEmail }}</span>
                  </span>
                }
              </div>
            </div>
          </aside>
        </ion-content>
      </ion-menu>

      <div id="main-content" class="admin-shell">

        @if(showHeader){
          <div class="admin-topbar admin-topbar__admin-mobile">
            <ion-toolbar>
              <ion-buttons slot="start" [routerLink]="'/home'">
                <img class="admin-topbar__mobile-logo" src="assets/icon/em_icon.svg" alt="EnergyMaster">
              </ion-buttons>

              <ion-buttons slot="end">
                <ion-button class="admin-topbar__notification" fill="clear" type="button" [routerLink]="'/notifications'">
                  <fa-icon [icon]="faBell" aria-hidden="true"></fa-icon>
                </ion-button>
                <ion-menu-button
                  class="admin-topbar__menu-button"
                  menu="admin-menu"
                  (click)="openMenu()"
                  [autoHide]="false"
                  [attr.aria-label]="'nav.open_admin_menu' | translate"
                >
                  <fa-icon [icon]="faBars" aria-hidden="true"></fa-icon>
                </ion-menu-button>
              </ion-buttons>
            </ion-toolbar>
          </div>
        }
        <ion-router-outlet class="admin-router-outlet"></ion-router-outlet>
      </div>
    </ion-split-pane>
  } @else {

    <div id="main-content" class="admin-shell" [class.admin-shell--user]="isAuthenticated">
      <app-impersonation-banner />
      <div class="user-shell-content" [class.user-shell-content--impersonation]="isImpersonating">
      @if(isAuthenticated){
        <div class="admin-topbar">
          <ion-toolbar>
            <ion-buttons slot="start" [routerLink]="'/home'">
              <img class="admin-topbar__mobile-logo" src="assets/icon/em_icon.svg" alt="EnergyMaster">
            </ion-buttons>
            <ion-buttons slot="start">
              <img class="topbar_logo" src="assets/icon/em_logo_black.svg" alt="EnergyMaster">
            </ion-buttons>


            <ion-buttons class="flex items-center justify-center top-menu-items">
              @for (custRout of customerRoutes; track custRout.label){
                <ion-button [fill]="isActiveRoute(custRout.activeRoutes ?? []) ? 'solid' : 'clear'" type="button" shape="round" [routerLink]="custRout.route" color="{{isActiveRoute(custRout.activeRoutes ?? []) ? 'primary' : 'dark'}}" [disabled]="custRout.disabled ?? false">
                  {{ custRout.label | translate }}
                </ion-button>
              }
            </ion-buttons>
            <ion-buttons slot="end">
<!--              <ion-button class="topbar_button" fill="clear" type="button">
                <fa-icon [icon]="faMagnifyingGlass" aria-hidden="true"></fa-icon>
              </ion-button>-->
              <ion-button class="topbar_button" fill="clear" type="button" [routerLink]="'/notifications'">
                <fa-icon [icon]="faBell" aria-hidden="true"></fa-icon>
              </ion-button>
            </ion-buttons>
          </ion-toolbar>
        </div>
      }

    <ion-router-outlet></ion-router-outlet>

      @if(isAuthenticated){
        <div class="footer-bar">
            <ion-toolbar>
              <ion-buttons class="flex items-center justify-between">
                <ion-button class="footer-bar-button" [color]="isActiveRoute(homeRoutes) ? 'primary' : 'dark'" [fill]="isActiveRoute(homeRoutes) ? 'solid' : 'clear'" type="button" [shape]="'round'" (click)="routeTo('/')">
                  <fa-icon [icon]="faLocationDot" aria-hidden="true"></fa-icon>
                </ion-button>
                <ion-button class="footer-bar-button" [color]="isActiveRoute(reportsAndTrendsRoutes) ? 'primary' : 'dark'" [fill]="isActiveRoute(reportsAndTrendsRoutes) ? 'solid' : 'clear'" type="button" [shape]="'round'" [routerLink]="'/reports-and-trends'">
                  <fa-icon [icon]="faChartLineUp" aria-hidden="true"></fa-icon>
                </ion-button>
                <ion-button class="footer-bar-button" fill="clear" type="button" [shape]="'round'" [disabled]="true">
                  <fa-icon [icon]="faDial" aria-hidden="true"></fa-icon>
                </ion-button>
                <ion-button class="footer-bar-button" [fill]="isActiveRoute(moduleRoutes)  ? 'solid' : 'clear'" [color]="isActiveRoute(moduleRoutes) ? 'primary' : 'dark'" type="button" [shape]="'round'" (click)="routeTo('/module/modules')">
                  <fa-icon [icon]="faMobileRetro" aria-hidden="true"></fa-icon>
                </ion-button>
                <ion-button class="footer-bar-button" [fill]="userMenuModalOpen || isActiveRoute(profileRoutes)  ? 'solid' : 'clear'" [color]="userMenuModalOpen || isActiveRoute(profileRoutes) ? 'primary' : 'dark'" type="button" [shape]="'round'" (click)="openUserMenuModal()">
                  <fa-icon [icon]="faEllipsis" aria-hidden="true"></fa-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
        </div>
      }
      </div>
    </div>
  }
</ion-app>
